/**
 * The languages the device says its user reads, most preferred first:
 * `navigator.languages`, else the single `navigator.language`, else nothing.
 */
export function deviceLanguages(): readonly string[] {
  const { language, languages } = navigator;
  if (languages && languages.length > 0) {
    return languages;
  }
  return language ? [language] : [];
}
